export default __webpack_public_path__ + "static/media/arrow-accordion.efc2861c.svg";